import React, { ReactNode, useState, useEffect, useContext } from 'react';

import { cmnContext } from './CmnContext';

type CmnWrapProps = {
  children: ReactNode;
};

const CmnWrap = ({ children }: CmnWrapProps) => {

  const [isPc, setIsPc] = useState<boolean>(true);
  // 初心者画像
  const beginnerImg = '/images/common/beginner.png';


  useEffect(() => {
    const handleResize = () => {
      setIsPc(window.innerWidth >= 768);
    };
    // 初回確認
    handleResize();
    // 画面サイズ変更時
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const contextVal = {
    isPc: isPc,
    beginnerImg: beginnerImg,
  }

  return (
    <cmnContext.Provider value={contextVal}>
      {children}
    </cmnContext.Provider>
  );
};

export default CmnWrap;